import { useState } from 'react';
import { Redirect } from 'react-router';
import { Switch, Link } from 'react-router-dom';
import { Image, Icon, Button } from 'semantic-ui-react';
import { ProtectedRoute } from '../ProtectedRoute/ProtectedRoute';
import { InviteUsersPage } from '../InviteUsersPage/InviteUsersPage';
import { OrganisationParticipantSummaryReportPage } from '../OrganisationParticipantSummaryReportPage/OrganisationParticipantSummaryReportPage';
import { OverallSummaryReportPage } from '../OverallSummaryReportPage/OverallSummaryReportPage';
import { OrganisationStatePage } from '../OrganisationStatePage/OrganisationStatePage';
import { OrganisationMembersPage } from '../OrganisationMembersPage/OrganisationMembersPage';
// import { PricesRevisionPage } from '../PricesRevisionPage/PricesRevisionPage';
import { PriceRevisionLogsPage } from '../PriceRevisionLogsPage/PriceRevisionLogsPage';
import { NewPricesPage } from '../NewPricesPage/NewPricesPage';
import './AdminPage.less';

export const AdminPage: React.FC = () => {
	const [menuOpen, toggleMenu] = useState(false);

	return (
		<div className='admin-container'>
			<div className={'admin-sidebar' + (menuOpen ? '' : ' hidden')}>
				<div
					className='admin-sidebar-backdrop'
					onClick={() => toggleMenu(!menuOpen)}
				/>
				<nav className='admin-sidebar-menu'>
					<h2>
						<Link to={'/'}>
							<Image
								className='admin-logo'
								src={process.env.PUBLIC_URL + '/logo.png'}
							/>
						</Link>
						Admin Control Panel
					</h2>
					<h3>Organisation</h3>
					<ul onClick={() => toggleMenu(false)}>
						<li>
							<Link to={'/register/5'}>Create New Organisation</Link>
						</li>
						<li>
							<Link to={'/admin/org/manage'}>Manage Organisations</Link>
						</li>
						<li>
							<Link to={'/admin/org/unselected/members'}>Manage Members</Link>
						</li>
						<li>
							<Link to={'/admin/org/invite'}>Invite Members</Link>
						</li>
					</ul>
					<h3>Prices</h3>
					<ul onClick={() => toggleMenu(false)}>
						<li>
							<Link to={'/admin/prices'}>Revisions</Link>
						</li>
						<li>
							<Link to={'/admin/prices/new'}>
								New Revision (CSV)
							</Link>
						</li>
					</ul>
					<h3>Reports</h3>
					<ul onClick={() => toggleMenu(false)}>
						<li>
							<Link to={'/admin/report/overallsummary'}>
								Overall Summary
							</Link>
						</li>
						<li>
							<Link to={'/admin/report/organisationparticipant'}>
								Organisation Participant Summary
							</Link>
						</li>
					</ul>
				</nav>
			</div>
			<div className='admin-content'>
				<div className='admin-topbar'>
					<Button icon onClick={() => toggleMenu(!menuOpen)}>
						<Icon name='content' />
					</Button>
					<h2>Admin Control Panel</h2>
				</div>
				<Switch>
					<ProtectedRoute
						path='/admin/org/invite'
						adminOnly={true}
						component={InviteUsersPage}
					/>
					<ProtectedRoute
						path='/admin/org/manage'
						adminOnly={true}
						component={OrganisationStatePage}
					/>
					<ProtectedRoute
						path='/admin/org/:orgId/members'
						adminOnly={true}
						component={OrganisationMembersPage}
					/>
					<ProtectedRoute
						path='/admin/report/organisationparticipant'
						adminOnly={true}
						component={OrganisationParticipantSummaryReportPage}
					/>
					<ProtectedRoute
						path='/admin/report/overallsummary'
						adminOnly={true}
						component={OverallSummaryReportPage}
					/>
					<ProtectedRoute
						path='/admin/prices'
						adminOnly={true}
						exact={true}
						component={PriceRevisionLogsPage}
					/>
					{/* <ProtectedRoute
						path='/admin/prices/new'
						adminOnly={true}
						component={PricesRevisionPage}
					/> */}
					<ProtectedRoute
						path='/admin/prices/new'
						adminOnly={true}
						component={NewPricesPage}
					/>
					<Redirect to={'/admin/org/manage'} />
				</Switch>
			</div>
		</div>
	);
};

export default AdminPage;
